import Vue from "vue";
import formatter from "@/plugins/formatter";

Vue.filter("decimal", (value) => {
    let val = +value;
    return formatter.decimalToString(val);
});